import { useAppDispatch, useAppSelector } from "@/core/app/hooks"
import { updateCaseById } from "@/core/app/slices/case"
import { uploadZips } from "@/core/app/slices/clinical/clinical.service"
import { FILEZIPS } from "@/core/app/slices/clinical/clinicalSlice"
import { RootState } from "@/core/app/store"
import { UI_PERMISSION } from "@/core/utils/access/permissionConstants"
import { caseManagement } from "@/gluelayer"
import { CASE_STATUS } from "@/modules/Patient/config/status.config"
import { setData } from "@/core/app/slices/patients/patientSlice"
import { ROUTE_ATTENTION_BANNER } from "@/routes/status.route.config"
import { useMyNavigation } from "@/hooks/useMyNavigation"

type useSTLuploadProps = {
  newUdesignJson: {
    upperUploaded: boolean
    lowerUploaded: boolean
    UpperType: "A" | "R" | "" | "--"
    LowerType: "A" | "R" | "" | "--"
  }
  uassist_round: number
  patientId: string
  caseId: string
  callback?: () => void
}

function useSTLupload() {
  const dispatch = useAppDispatch()
  
  const {
    user: { app_permissions, current_orgId },
  } = useAppSelector((state: RootState) => state.userService)
  const { clinicalSettings } = useAppSelector(
    (state: RootState) => state.userService,
  )
  const { caseDetail } = useAppSelector((state: RootState) => state.caseService)
  const { caseDetailForShape, scannerSelect } = useAppSelector(
    (state: RootState) => state.patientService,
  )

  async function handleStlUpload({
    newUdesignJson,
    uassist_round,
    patientId,
    caseId,
    callback,
  }: useSTLuploadProps) {
    caseManagement
      .saveJsonDataToZip(
        JSON.stringify(clinicalSettings),
        "uassist_team_settings.json",
        "Setting Data2",
      )
      .then(() => {
        //const zip = uassist_round > 0 ? ["bulk10"] : [...FILEZIPS]// when click Next button in CreateRefinement,only upload bulk10.zip
        const zip = ["bulk10"]
        caseManagement.getCaseFiles(zip).then((r) => {
          console.log(
            "🚀 ~ caseManagement.getCaseFiles ~ rrrrrrrrrrrrrrrrrr:",
            r,
          )
          const zips = []
          if (r) {
            for (const k in r) {
              zips.push({
                fileName: k,
                file: r[k],
              })
            }
            uploadZips({
              zips,
              patientId,
              caseId,
              orgId: current_orgId,
              callback,
            })
          }
        })
      })
  }

  return {
    handleStlUpload,
  }
}

export default useSTLupload
